<template>
    <div class="events-recordings">
        <h2 class="uppercase pb-4">IATSE LOCAL 667 EVENTS RECORDINGS</h2>
        <p>Recordings of IATSE Local 667 sponsored events, meetings and training sessions are located here:</p>
        <p>
            <a href="https://vimeopro.com/ia667dp/zoom-recordings-667-members-only" target="_blank">IATSE Local 667 Event Recordings</a>
        </p>
        <p>Password: 667667</p>
        <p>If you cannot find a specific recording please reach out to the office.</p>
    </div>
</template>

<script>
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav";


    export default {
        name: "EventsRecordingIndex",

        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        data() {
            return {
                //
            }
        },
        mounted() {
           //
        },
        methods: {
           //
        },
    }
</script>
<style scoped>

.events-heading {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 16px;
}

a {
    color: #0645AD;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}
</style>
